/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník typů úloh pro zařízení.
 * @deprecated Nepoužívat, zůstává pouze pro potřeby zpětné kompatibility.
 * @enum {string}
 */
const TaskEnum = {
  /**
   * Obsahová úloha.
   * Odkazuje na objekt, který se má přehrát (medium, playlist, šablona).
   */
  CONTENT: 'CONTENT',
  /**
   * Řídící úloha.
   * Sdružuje časovače napájení zařízení.
   */
  POWER: 'POWER'
};

export default TaskEnum;
